// src/store/location.js
import { defineStore } from 'pinia'

// 定义并导出 Pinia 仓库（id 为唯一标识，必须唯一）
export const useLocationStore = defineStore('location', {
  // 状态：存储地区信息、定位状态
  state: () => ({
    area: '', // 用户地区（如：北京市）
    status: 'idle', // 定位状态：idle（未开始）/ loading（加载中）/ success（成功）/ error（失败）
    errorMsg: '' // 错误信息（定位失败时）
  }),

  // 动作：封装定位逻辑（异步操作写在 actions 中）
  actions: {
    // 核心方法：获取 IP 定位（公共方法，组件可调用）
    async fetchIPLocation () {
      // 避免重复定位（加载中时直接返回）
      if (this.status === 'loading') return

      // 开始定位：更新状态
      this.status = 'loading'
      this.errorMsg = ''

      try {
        // 调用免费 IP 定位 API（若失效可替换为其他接口，如：ipinfo.io/json）
        const response = await fetch('https://ipinfo.io/json/')

        if (!response.ok) throw new Error('定位接口请求失败')

        const data = await response.json()

        // 提取城市信息（不同 API 返回字段可能不同，需根据实际调整）
        const city = data.city || data.region || '未知地区'
        this.area = city // 更新状态：存储地区
        this.status = 'success' // 定位成功
      } catch (error) {
        // 定位失败：更新状态
        this.status = 'error'
        this.errorMsg = error.message
        this.area = '定位失败' // 兜底显示
      }
    }
  }
})
